export const COMPONENT_NAME = "kyb-participants";
